import { Link } from "react-router-dom";
import { HashLink } from "react-router-hash-link";
import React, { useState } from "react";
import BoostMenu from "common/BoostMenu";
import { useQueryParams } from "utils/hooks/useQueryParams";
import Logo from "../images/boost/boost_logo_light.svg";

const BoostHeader = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const withQueryParams = useQueryParams();

  return (
    <header className="py-3 md:py-5 flex justify-between items-center px-6 md:px-8 max-w-page bg-transparent">
      <div className="mr-4 ml-1 lg:mr-12 pb-1">
        <Link to={withQueryParams("/boost")}>
          <img
            alt="logo"
            src={Logo}
            className="w-32 md:w-48"
            style={{ height: "auto", minWidth: "150px" }}
          />
        </Link>
      </div>
      <div className="flex-1 text-dark md:hidden lg:inline-flex items-center text-white">
        <HashLink
          to={withQueryParams("/boost-how-it-works")}
          className="px-4 xl:px-6 hidden md:inline-block text-white hover:text-boost-purple-alt whitespace-nowrap font-medium text-lg"
        >
          How It Works
        </HashLink>
        <Link
          to={withQueryParams("/boost-faq")}
          className="px-4 xl:px-6 hidden md:inline-block text-white hover:text-boost-purple-alt whitespace-nowrap font-medium text-lg"
        >
          FAQs
        </Link>
        <HashLink
          to={withQueryParams("/boost-pricing")}
          className="px-4 xl:px-6 hidden md:inline-block text-white hover:text-boost-purple-alt whitespace-nowrap font-medium text-lg"
          onClick={(e) => e.currentTarget.focus()}
        >
          Pricing
        </HashLink>
        <a
          href="https://tomocredit.com/blog/"
          className="px-4 xl:px-6 hidden md:inline-block text-white hover:text-boost-purple-alt whitespace-nowrap font-medium text-lg"
        >
          Blog
        </a>
        {/* <Link
          to={withQueryParams("/ai")}
          className="px-4 xl:px-6 hidden md:inline-block text-white hover:text-boost-purple-alt whitespace-nowrap font-medium text-lg"
        >
          TomoAI
        </Link> */}
        <Link
          to={withQueryParams("/boost/ai")}
          className="px-4 xl:px-6 hidden md:inline-block text-white hover:text-boost-purple-alt whitespace-nowrap font-medium text-lg"
        >
          TomoIQ
        </Link>
        <Link
          to={withQueryParams("/boost/small-business")}
          className="px-4 xl:px-6 hidden md:inline-block text-white hover:text-boost-purple-alt whitespace-nowrap font-medium text-lg"
        >
          Business
        </Link>
        <span className="flex-1" />
        <a
          href={`${process.env.REACT_APP_DOMAIN}/dashboard/login?redirect_uri=/boost&fromBoost=true`}
          className="px-4 xl:px-6 hidden md:inline-block text-white hover:text-boost-purple-alt whitespace-nowrap text-lg font-medium"
          onClick={(e) => e.currentTarget.focus()}
        >
          Login
        </a>
      </div>
      <BoostMenu
        handleToggle={(state) => {
          setMenuOpen(state.isOpen);
        }}
        hidden={menuOpen}
      />
    </header>
  );
};

export default BoostHeader;
